module.exports = __webpack_public_path__ + "img/card-blog1.11ea313a.jpg";